const BACK_HOME_ATTR = "data-back-home"

export { BACK_HOME_ATTR }
